<section class="admin-page ct-page settings-page">
  <div class="ct-toolbar">
    <div class="settings-intro">
      <p class="subtitle">{{ 'settings.subtitle' | t }}</p>
      @if (businessKey()) {
        <p class="settings-business">
          <span class="settings-business-label">{{ 'settings.editingBusiness' | t }}</span>
          <strong>{{ businessKey() }}</strong>
        </p>
      }
    </div>
  </div>

  <nav class="settings-tabs" [attr.aria-label]="'settings.title' | t">
    <button
      type="button"
      class="settings-tab"
      [class.active]="tab() === 'features'"
      (click)="setTab('features')"
    >
      {{ 'settings.tab.features' | t }}
    </button>
    <button
      type="button"
      class="settings-tab"
      [class.active]="tab() === 'brand'"
      (click)="setTab('brand')"
    >
      {{ 'settings.tab.brand' | t }}
    </button>
    <button
      type="button"
      class="settings-tab"
      [class.active]="tab() === 'stripe'"
      (click)="setTab('stripe')"
    >
      {{ 'settings.tab.stripe' | t }}
    </button>
    <button
      type="button"
      class="settings-tab"
      [class.active]="tab() === 'email'"
      (click)="setTab('email')"
    >
      {{ 'settings.tab.email' | t }}
    </button>
    <button
      type="button"
      class="settings-tab"
      [class.active]="tab() === 'facebook'"
      (click)="setTab('facebook')"
    >
      {{ 'settings.tab.facebook' | t }}
    </button>
  </nav>

  @if (loading()) {
    <div class="ct-card settings-panel">
      <p class="settings-loading">{{ 'common.loading' | t }}</p>
    </div>
  } @else if (tab() === 'features') {
    <div class="ct-card settings-panel">
      <header class="panel-head">
        <h3>{{ 'settings.tab.features' | t }}</h3>
        <p>{{ 'settings.features.sectionDesc' | t }}</p>
      </header>

      <div class="feature-row">
        <div class="feature-copy">
          <strong>{{ 'settings.features.liveChat' | t }}</strong>
          <p>{{ 'settings.features.liveChatDesc' | t }}</p>
        </div>
        <label class="switch" [attr.aria-label]="'settings.features.liveChat' | t">
          <input type="checkbox" [checked]="liveChat()" (change)="liveChat.set($any($event.target).checked)" />
          <span class="switch-track" aria-hidden="true"></span>
        </label>
      </div>

      <div class="feature-row">
        <div class="feature-copy">
          <strong>{{ 'settings.features.aiMarketing' | t }}</strong>
          <p>{{ 'settings.features.aiMarketingDesc' | t }}</p>
        </div>
        <label class="switch" [attr.aria-label]="'settings.features.aiMarketing' | t">
          <input type="checkbox" [checked]="aiMarketing()" (change)="aiMarketing.set($any($event.target).checked)" />
          <span class="switch-track" aria-hidden="true"></span>
        </label>
      </div>

      <footer class="panel-foot">
        <button type="button" class="ct-btn ct-btn-primary" [disabled]="saving()" (click)="saveFeatures()">
          {{ 'common.save' | t }}
        </button>
      </footer>
    </div>
  } @else if (tab() === 'brand') {
    <form class="ct-card settings-panel" [formGroup]="brandForm" (ngSubmit)="saveBrand()">
      <header class="panel-head">
        <h3>{{ 'settings.tab.brand' | t }}</h3>
        <p>{{ 'settings.brand.sectionDesc' | t }}</p>
      </header>

      <div class="ct-form-grid">
        <div class="ct-field">
          <label for="brand-display-name">{{ 'settings.brand.displayName' | t }}</label>
          <input id="brand-display-name" class="ct-input" type="text" formControlName="displayName" />
        </div>
      </div>

      <footer class="panel-foot">
        <button type="submit" class="ct-btn ct-btn-primary" [disabled]="saving()">
          {{ 'common.save' | t }}
        </button>
      </footer>
    </form>
  } @else if (tab() === 'stripe') {
    <div class="settings-stripe">
      <form class="ct-card settings-panel" [formGroup]="stripeForm" (ngSubmit)="saveStripe()">
        <header class="panel-head">
          <h3>{{ 'settings.tab.stripe' | t }}</h3>
          <p>{{ 'settings.stripe.sectionDesc' | t }}</p>
        </header>

        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="stripe-publishable">{{ 'settings.stripe.publishableKey' | t }}</label>
            <input id="stripe-publishable" class="ct-input" type="text" formControlName="publishableKey" autocomplete="off" />
          </div>
          <div class="ct-field">
            <label for="stripe-secret">{{ 'settings.stripe.secretKey' | t }}</label>
            <input
              id="stripe-secret"
              class="ct-input"
              type="password"
              formControlName="secretKey"
              autocomplete="new-password"
              [placeholder]="stripeHasSecretKey ? ('settings.secretPlaceholder' | t) : ''"
            />
          </div>
          <div class="ct-field">
            <label for="stripe-webhook">{{ 'settings.stripe.webhookSecret' | t }}</label>
            <input
              id="stripe-webhook"
              class="ct-input"
              type="password"
              formControlName="webhookSecret"
              autocomplete="new-password"
              [placeholder]="stripeHasWebhookSecret ? ('settings.secretPlaceholder' | t) : ''"
            />
            <p class="hint">{{ 'settings.stripe.webhookSecretHint' | t }}</p>
          </div>
        </div>

        <footer class="panel-foot">
          <button type="submit" class="ct-btn ct-btn-primary" [disabled]="saving()">
            {{ 'common.save' | t }}
          </button>
        </footer>
      </form>

      <section class="ct-card settings-panel">
        <header class="panel-head">
          <h3>{{ 'settings.stripe.webhooksTitle' | t }}</h3>
          <p>{{ 'settings.stripe.webhooksDesc' | t }}</p>
        </header>

        @if (!stripeHasSecretKey) {
          <p class="hint">{{ 'settings.stripe.webhooksNeedSecret' | t }}</p>
        } @else {
          @if (webhookExpectedPath()) {
            <p class="webhook-path">
              <span class="settings-business-label">{{ 'settings.stripe.webhookExpectedPath' | t }}</span>
              <code>{{ webhookExpectedPath() }}</code>
            </p>
          }

          <div class="webhook-create" [formGroup]="webhookForm">
            <div class="ct-field">
              <label for="stripe-webhook-base">{{ 'settings.stripe.webhookBaseUrl' | t }}</label>
              <input
                id="stripe-webhook-base"
                class="ct-input"
                type="url"
                formControlName="baseUrl"
                placeholder="https://example.com"
                autocomplete="off"
              />
            </div>
            @if (webhookSuggestedBaseUrls().length > 0) {
              <div class="webhook-suggestions">
                @for (url of webhookSuggestedBaseUrls(); track url) {
                  <button type="button" class="ct-btn ct-btn-ghost webhook-suggest" (click)="useSuggestedBaseUrl(url)">
                    {{ url }}
                  </button>
                }
              </div>
            }
            <button
              type="button"
              class="ct-btn ct-btn-primary"
              [disabled]="webhooksBusy() || webhooksLoading()"
              (click)="createWebhook()"
            >
              {{ 'settings.stripe.webhookCreate' | t }}
            </button>
          </div>

          @if (webhooksLoading()) {
            <p class="settings-loading">{{ 'common.loading' | t }}</p>
          } @else if (webhookEndpoints().length === 0) {
            <p class="hint">{{ 'settings.stripe.webhooksEmpty' | t }}</p>
          } @else {
            <ul class="webhook-list">
              @for (endpoint of webhookEndpoints(); track endpoint.id) {
                <li class="webhook-row" [class.webhook-row--match]="endpoint.matchesCurrentBusiness">
                  <div class="webhook-copy">
                    <code class="webhook-url">{{ endpoint.url }}</code>
                    <p class="webhook-meta">
                      <span>{{ endpoint.status }}</span>
                      @if (endpoint.matchesCurrentBusiness) {
                        <span class="webhook-badge">{{ 'settings.stripe.webhookMatchesBusiness' | t }}</span>
                      }
                      @if (endpoint.description) {
                        <span>{{ endpoint.description }}</span>
                      }
                    </p>
                  </div>
                  <button
                    type="button"
                    class="ct-btn ct-btn-ghost"
                    [disabled]="webhooksBusy()"
                    (click)="deleteWebhook(endpoint)"
                  >
                    {{ 'common.delete' | t }}
                  </button>
                </li>
              }
            </ul>
          }
        }
      </section>
    </div>
  } @else if (tab() === 'email') {
    <form class="ct-card settings-panel" [formGroup]="emailForm" (ngSubmit)="saveEmail()">
      <header class="panel-head">
        <h3>{{ 'settings.tab.email' | t }}</h3>
        <p>{{ 'settings.email.sectionDesc' | t }}</p>
      </header>

      <div class="ct-form-grid">
        <div class="ct-field">
          <label for="email-domain">{{ 'settings.email.domain' | t }}</label>
          <input
            id="email-domain"
            class="ct-input"
            type="text"
            formControlName="domain"
            autocomplete="off"
          />
        </div>
        <div class="ct-field">
          <label for="email-order-user">{{ 'settings.email.orderUserName' | t }}</label>
          <input id="email-order-user" class="ct-input" type="text" formControlName="orderUserName" autocomplete="off" />
        </div>
        <div class="ct-field">
          <label for="email-order-from">{{ 'settings.email.orderFromName' | t }}</label>
          <input id="email-order-from" class="ct-input" type="text" formControlName="orderFromName" />
        </div>
        <div class="ct-field">
          <label for="email-reset-user">{{ 'settings.email.passwordResetUserName' | t }}</label>
          <input
            id="email-reset-user"
            class="ct-input"
            type="text"
            formControlName="passwordResetUserName"
            autocomplete="off"
          />
        </div>
        <div class="ct-field">
          <label for="email-reset-from">{{ 'settings.email.passwordResetFromName' | t }}</label>
          <input id="email-reset-from" class="ct-input" type="text" formControlName="passwordResetFromName" />
        </div>
      </div>

      <footer class="panel-foot email-actions">
        <button type="submit" class="ct-btn ct-btn-primary" [disabled]="saving() || testingEmail()">
          {{ 'common.save' | t }}
        </button>
        <button
          type="button"
          class="ct-btn ct-btn-ghost"
          [disabled]="saving() || testingEmail()"
          (click)="sendTestEmail()"
        >
          {{ testingEmail() ? ('settings.email.testing' | t) : ('settings.email.test' | t) }}
        </button>
      </footer>
    </form>
  } @else if (tab() === 'facebook') {
    <form class="ct-card settings-panel" [formGroup]="facebookForm" (ngSubmit)="saveFacebook()">
      <header class="panel-head">
        <h3>{{ 'settings.tab.facebook' | t }}</h3>
        <p>{{ 'settings.facebook.sectionDesc' | t }}</p>
      </header>

      <div class="ct-form-grid">
        <div class="ct-field">
          <label for="facebook-app-id">{{ 'settings.facebook.appId' | t }}</label>
          <input id="facebook-app-id" class="ct-input" type="text" formControlName="appId" autocomplete="off" />
        </div>
        <div class="ct-field">
          <label for="facebook-app-secret">{{ 'settings.facebook.appSecret' | t }}</label>
          <input
            id="facebook-app-secret"
            class="ct-input"
            type="password"
            formControlName="appSecret"
            autocomplete="new-password"
            [placeholder]="facebookHasAppSecret ? ('settings.secretPlaceholder' | t) : ''"
          />
        </div>
      </div>

      <footer class="panel-foot">
        <button type="submit" class="ct-btn ct-btn-primary" [disabled]="saving()">
          {{ 'common.save' | t }}
        </button>
      </footer>
    </form>
  }
</section>
